export default __webpack_public_path__ + "static/media/277022__sandermotions__applause-1.2cf86df0.wav";